// extracted by mini-css-extract-plugin
export default {"FolderPopupButton":"FolderPopupButton_FolderPopupButton__+KBIM","Icon":"FolderPopupButton_Icon__TOFfj","swing-in":"FolderPopupButton_swing-in__jhUJd"};